<template>
  <div id="app" class="min-h-screen flex flex-col bg-gray-200">
    <div class="flex-grow bg-gradient-to-br from-[#2BADBD] via-[#259BAA] to-white">
      <router-view />
    </div>
    <div class="h-2 bg-[#249c38]"></div>
    <FooterSection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterSection from '@/components/FooterSection.vue'

export default defineComponent({
  name: 'App',
  components: {
    FooterSection
  }
});
</script>
